import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Select from "react-select";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Utils from "../../common/manipurCommon/Utils";

const Schedules = () => {

    const [scheduleList, setScheduleList] = useState<any[]>([]);
    const [batchList, setBatchList] = useState<any[]>([]);
    const [skillList, setSkillList] = useState<any[]>([]);
    const [scheduleId, setScheduleId] = useState("");
    const [batchId, setBatchId] = useState("");
    const [skillId, setSkillId] = useState("");
    const [scdlDate, setScdlDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [comment, setComment] = useState("");
    const [scdlStatus, setScdlStatus] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        fetchSchedules();
    }, [])

        async function fetchSchedules() {
            setIsLoading(true);
            const scheduleResponse = await func.Schedules(null);
            setScheduleList(Array.isArray(scheduleResponse) ? scheduleResponse : [])
            setIsLoading(false);
        }

    const filteredData = scheduleList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    // const displayedData = filteredData.map((item, index) => ({
    //     ...item,
    //     // slNo: filteredData.length - index
    //     slNo: index + 1,
    // }));

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchNameRender = (rowData) => {
        return <span>{rowData.batchName}</span>
    }

    const skillNameRender = (rowData) => {
        return <span>{rowData.talentScoutingTestName}</span>
    }

    const scheduleDateRender = (rowData) => {
        return <span>{formatDate(rowData.scheduleDate)}</span>
    }

    const startTimeRender = (rowData) => {
        return <span>{rowData.scheduleStartTime}</span>
    }

    const endTimeRender = (rowData) => {
        return <span>{rowData.scheduleEndTime}</span>
    }

    const scheduleStatusRender = (rowData) => {
        return <span>{(rowData.scheduleStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editSchedule(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const scdlId = rowData.scheduleId;
        return (
            <Link to="#" onClick={() => deleteSchedule(scdlId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    async function newSchedule() {
        setIsEdit(false)
        setOpenModal(true)
        setBatchId("")
        setSkillId("")
        setScdlDate("")
        setStartTime("")
        setEndTime("")
        setComment("")
        const btchResponse = await func.listBatches();
        setBatchList(Array.isArray(btchResponse) ? btchResponse : [])
        const skillResponse = await func.listTalentScouting();
        setSkillList(Array.isArray(skillResponse) ? skillResponse : [])
    }

    async function editSchedule(rowData: { scheduleId: string | number; }) {
        const scdlId = rowData.scheduleId;
        setIsEdit(true)
        setOpenModal(true)
        const getDetails = await func.Schedules(scdlId);
        const btchResponse = await func.listBatches();
        setBatchList(Array.isArray(btchResponse) ? btchResponse : [])
        const skillResponse = await func.listTalentScouting();
        setSkillList(Array.isArray(skillResponse) ? skillResponse : [])
        setScheduleId(getDetails.scheduleId)
        setBatchId(getDetails.scheduleBatchId)
        setSkillId(getDetails.talentScoutingId)
        setScdlDate(getDetails.scheduleDate)
        setStartTime(getDetails.scheduleStartTime)
        setEndTime(getDetails.scheduleEndTime)
        setComment(getDetails.scheduleComments)
        setScdlStatus(getDetails.scheduleStatus)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateSchdule();
            } else {
                const formData = new FormData();
                formData.append("batch", batchId);
                formData.append("test", skillId);
                formData.append("date", scdlDate);
                formData.append("startTime", startTime);
                formData.append("EndTime", endTime);
                formData.append("comment", comment);

                const createScdl = api.Schedules;
                fetch(createScdl, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchSchedules();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    function updateSchdule() {
        const formData = new FormData();
        formData.append("batch", batchId);
        formData.append("test", skillId);
        formData.append("date", scdlDate);
        formData.append("startTime", startTime);
        formData.append("EndTime", endTime);
        formData.append("comment", comment);
        formData.append("status", scdlStatus);

        const updateScdl = api.Schedules + "/" + scheduleId;
        fetch(updateScdl, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchSchedules();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteSchedule(scdlId: string) {
        const formData = new FormData();
        formData.append("status", '0');
        const delteScdl = api.Schedules + "/" + scdlId;
        fetch(delteScdl, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchSchedules();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Schedules</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newSchedule() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Schedule">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            // value={displayedData}
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="batchName"
                                                header="Batch Name"
                                                body={batchNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="skillName"
                                                header="Skill Name"
                                                body={skillNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="scheduleDate"
                                                header="Schedule Date"
                                                body={scheduleDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="scheduleStartTime"
                                                header="Start Time"
                                                body={startTimeRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="scheduleEndTime"
                                                header="End Time"
                                                body={endTimeRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="scheduleStatus"
                                                header="Schedule Status"
                                                body={scheduleStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    show={openModal}
                    size="md"
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Schedule</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="col-lg-12 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Batch</label>
                                    <Select
                                        value={batchList.find(btch => btch.batchId === batchId) ? {
                                            value: batchId,
                                            label: batchList.find(btch => btch.batchId === batchId).batchName
                                        } : null}
                                        onChange={async (e) => {
                                            setBatchId(e.value);
                                        }}
                                        required
                                        placeholder="Select Batch"
                                        options={batchList.map(btch => ({
                                            value: btch.batchId,
                                            label: btch.batchName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-12 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Test</label>
                                    <Select
                                        value={skillList.find(skl => skl.talentScoutingId === skillId) ? {
                                            value: skillId,
                                            label: skillList.find(skl => skl.talentScoutingId === skillId).talentScoutingTestName
                                        } : null}
                                        onChange={async (e) => {
                                            setSkillId(e.value);
                                        }}
                                        required
                                        placeholder="Select Test"
                                        options={skillList.map(skl => ({
                                            value: skl.talentScoutingId,
                                            label: skl.talentScoutingTestName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-12 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Schedule Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="scdlDate"
                                        placeholder="Select Date"
                                        required
                                        value={scdlDate}
                                        onChange={(e) => setScdlDate(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="row mb-10">
                                <div className="col d-flex justify-content-between">
                                    <div className="col-lg-5">
                                        <label className="form-label">Start Time</label>
                                        <input
                                            type="time"
                                            className="form-control"
                                            id="startTime"
                                            placeholder="Start Time"
                                            required
                                            value={startTime}
                                            onChange={(e) => setStartTime(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-lg-5">
                                        <label className="form-label">End Time</label>
                                        <input
                                            type="time"
                                            className="form-control"
                                            id="startTime"
                                            placeholder="Start Time"
                                            required
                                            value={endTime}
                                            onChange={(e) => setEndTime(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Schedule Comment</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="ScdlCmnt"
                                        placeholder="Schedule Comment"
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                    />
                                </div>
                            </div>
                            {isEdit ?
                                <>
                                    <div className="row">
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={scdlStatus === '1'}
                                                    id="scdlStatus"
                                                    onChange={(e) => {
                                                        setScdlStatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                            }
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </>
    )
};

export default Schedules;